var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panel"},[_vm._m(0),_c('div',{staticClass:"panel-content"},[_c('p',[_vm._v("Type of document:")]),_c('b-btn',{attrs:{"variant":"link","to":"/paper/sgdatalogger"}},[_vm._v("Singapore: data loggers for mobile cranes (OSHD/SPECS/ESB/LE/02/2015)")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-heading"},[_c('h3',[_vm._v("Legal compliance")])])
}]

export { render, staticRenderFns }